import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuBar from '../common/MenuBar';
import Footer from '../common/Footer';
import VerticalMenu from '../common/VerticalMenu';
import ButtonToTop from '../common/ButtonToTop';
import WhatsAppButton from '../common/WhatsAppButton';
import PhoneButton from '../common/PhoneButton';




import { I18nextProvider } from "react-i18next";
import i18n from "../../i18n";

/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/


// import common_en from "../../locale/en/common";
// import common_es from "../../locale/es/common";


// i18next.init({
//   interpolation: { escapeValue: false },  // React already does escaping
//   lng: 'en',                              // language to use
//   resources: {
//     en: {
//       common: common_en               // 'common' is our custom namespace
//     },
//     de: {
//       common: common_es
//     },
//   },
// });


export default class App extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: '',
  };


  render() {
    return (
      <I18nextProvider i18n={i18n}>
        <div className="home-app">
          {/* <MenuBar/> */}
          <VerticalMenu />
          <div className="page-container">{this.props.children}</div>
          <Footer />
          <PhoneButton />
          <WhatsAppButton />
          <ButtonToTop />
        </div>
      </I18nextProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/App.js